import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledGhostButton = styled(Link)`
color: white !important;
text-transform: uppercase;
text-decoration: none;
background: transparent;
padding: 20px;
border: 4px solid orange !important;
display: inline-block;
transition: all 0.4s ease 0s;
letter-spacing: 2px;
cursor: pointer;
margin-bottom: 40px;
font-family: "Roboto", sans-serif;
 
 &:hover {
color: black !important;
background: orange;
font-weight: 700;
font-size: 1.2rem;
letter-spacing: 3px;
transition: all 0.4s ease 0s;
text-decoration: none;
 }
`;

export default StyledGhostButton;
